export default "__VITE_ASSET__DqkRN6B0__"